import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="frame-reload" on a <turbo-frame>, with the
// page to reload it from in data-frame-reload-url-value. While the frame
// holds [data-frame-reload-pending] (an
// accounting entry being written in the background, C.2), it reloads every
// few seconds, a bounded number of times, then stops.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 3000 }, max: { type: Number, default: 20 } }

  connect() {
    this.count = 0
    this.onLoad = () => this.schedule()
    this.element.addEventListener("turbo:frame-load", this.onLoad)
    this.schedule()
  }

  disconnect() {
    clearTimeout(this.timer)
    this.element.removeEventListener("turbo:frame-load", this.onLoad)
  }

  schedule() {
    clearTimeout(this.timer)
    if (!this.element.querySelector("[data-frame-reload-pending]") || this.count >= this.maxValue) return

    this.timer = setTimeout(() => {
      this.count += 1
      // Setting src loads the frame from the document's page; a src written in
      // the page itself is refused by Turbo (« references itself »).
      this.element.removeAttribute("src")
      this.element.src = this.urlValue
    }, this.intervalValue)
  }
}
